export const LOCALE_KEY = "LOCALE_ECOMM";
